<template>
  <div class="tile-content">
    <div class="tile-content-title">
      <CardTooltip
        v-if="tooltip"
        :tooltip="tooltip"
        size="x-large"
      />
      <TitleWithLink
        v-if="title"
        v-bind="$props"
        @openLink="dispatchAndEmit"
      />
    </div>
    <slot name="chart"/>
    <slot name="table"/>
  </div>
</template>

<script>
import CardTooltip from './Tooltips/CardTooltip/index.vue';
import TitleWithLink from './TitleWithLink';
import eventDispatcher from '../../../events/dispatch';

export default {
  props: {
    title: String,
    color: String,
    errorMessage: String,
    tooltip: String,
  },
  components: {
    CardTooltip,
    TitleWithLink,
  },
  methods: {
    dispatchAndEmit() {
      eventDispatcher(
        'dataTileLinkClick',
        { link_name: this.title },
      );

      this.$emit('iconClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.tile-content-title {
  display: flex;
}

.tile-content {
  display: flex;
  flex-direction: column;
  height: fit-content;
  gap: 16px;
}

::v-deep .kpi-tooltip-icon {
  position: initial;
  margin-top: 3px;
  z-index: 1;
}

::v-deep .tooltip-wrapper {
  width: 140px;
}

::v-deep .left.tooltip-wrapper {
  left: 50%;
  margin-left: -26px;
}
</style>
